import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import endpoints from "src/app/helpers/endpoints";
import { SidenavService } from "src/app/layout/sidenav/sidenav.service";
import { ApiService } from "src/app/services/api.service";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { EventService } from "src/app/services/event.service";
import { UserData } from "src/app/models/user-data.models";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { ErrorType } from "src/app/enums/error-type.enum";
import {Location} from '@angular/common';
import { MatDialog } from "@angular/material/dialog";
import { ChargeManuallyModalComponent } from "../../components/modals/charge-manually-modal/charge-manually-modal.component";
import { ComplaintModalComponent } from "../../components/modals/complaint-modal/complaint-modal.component";
import { CustomerDashboardService } from "../../services/customer-dashboard.service";

@Component({
  selector: "fury-customer-dashboard-general",
  templateUrl: "./customer-dashboard-general.component.html",
  styleUrls: ["./customer-dashboard-general.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class CustomerDashboardGeneralComponent implements OnInit, OnDestroy {
  panelOpenState = false;
  isSideMenuOpen = false;
  userId = "";
  userData: any;
  services: any;
  ngUnsubscribe = new Subject<void>();
  editorAccess = false;
  kpiData: any = null;
  isFetchChargeManuallyApi = false;
  allStates = [];
  constructor(
    private sidenavService: SidenavService,
    private router: Router,
    private event: EventService,
    private activateRoute: ActivatedRoute,
    private apiService: ApiService,
    private dialog: MatDialog,
    public location: Location,
    private customerDashboardService: CustomerDashboardService
  ) {}

  ngOnInit(): void {
    this.sidenavService.close();
    this.sidenavService.open$.subscribe((ele) => (this.isSideMenuOpen = ele));
    this.event.userData.subscribe((res: UserData) => {
      this.editorAccess = res.editorAccess;
    });
    this.userId = this.activateRoute.snapshot.params["id"];
    this.getCustomerDashboardKpi();
    this.getServices();
    this.getAllstate();
  }

  getServices() {
    this.apiService
      .get(endpoints.partners.serviceProvider.getServices)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res?.body) {
            this.services = res.body?.services;
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }

  getCustomerDashboardKpi() {
    this.apiService
      .get(endpoints.customerDashboard.getCustomerDashboardKpi(this.userId))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res?.body) {
            this.kpiData = res.body;
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.error?.message, ErrorType.Error);
        },
      });
  }

  toggleSideMenu() {
    this.isSideMenuOpen = !this.isSideMenuOpen;
    if (this.isSideMenuOpen) {
      this.sidenavService.open();
    } else {
      this.sidenavService.close();
    }
  }

  handleEditCustomer() {
    this.router.navigate([`/customer-dashboard/${this.userId}/edit`]);
  }

  handleEditFeedback() {
    this.customerDashboardService.handleFeedbackRequest(this.userId, null, false, null, null);
  }

  handleAddNotes() {
    this.customerDashboardService.handleAddNotes(this.userId, null, false, null, null);
  }

  handleAddClaim() {
    this.router.navigate([`/customer-dashboard/${this.userId}/file-a-claim`]);
  }

  handleSpecialRequest() {
    this.customerDashboardService.handleSpecialRequest(this.userId);
  }
  
  handleAddAgreement() {
    this.router.navigate([`/customer-dashboard/${this.userId}/add-agreement`]);
  }
  handleChargeManually() {
    this.dialog
    .open(ChargeManuallyModalComponent, {
      width: "600px",
      panelClass: "payment-info",
      data: this.userId
    })
    .afterClosed()
    .subscribe((res: any) => {
      if(res){
        this.isFetchChargeManuallyApi = !this.isFetchChargeManuallyApi;
      }
    });
  }

  handleAddComplaint() {
    this.dialog
      .open(ComplaintModalComponent, {
        data: {userId : this.userId},
        width: "600px",
        panelClass: "payment-info",
      })
      .afterClosed()
      .subscribe((res: any) => {
        if (!res?.actionValue) return;
  
      });
  }

  reload() {
    window.location.reload()
  }
  redirectToCustomerList(){
    this.router.navigateByUrl("/consumers/customers-list");
  }
  getAllstate() {
    this.apiService
      .get(endpoints.customerDashboard.getAllState)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: HttpResponse<any>) => {
          if (res.body) {
            this.allStates = res.body?.states.data;
            this.customerDashboardService.setStates(this.allStates || []);
          }
        },
        (err: HttpErrorResponse) => {
          this.customerDashboardService.setStates([]);
          this.apiService.alert(err.message, ErrorType.Error);
        }
      );
    }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
